const state = {
  cartCount: 0
}
export default state
